import React from "react";

export default function DietFilter({ diets, selectedDiet, handleDietClick }) {
  return (
    <div className="menu-diet-filter">
      {diets.map((diet) => (
        <button
          key={diet}
          className={`menu-diet-pill ${selectedDiet === diet ? "active" : ""}`}
          onClick={() => handleDietClick(diet)}
        >
          {diet}
        </button>
      ))}
    </div>
  );
}